const urls = {
  saveLocalData: '/ppt-plugin/activities',
  getLocalData: (presentationId: string) => `/ppt-plugin/activities/${presentationId}`,
} as const;

export default urls;
